module.exports = __webpack_public_path__ + "img/ejoyLogo.e2712742.svg";